import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {h, reactive, watch} from "vue";
import {EditOutlined} from "@ant-design/icons-vue";
import {useRoute} from "vue-router";
import {AEditor} from "@/views/editor/service/editor";


export default /*@__PURE__*/_defineComponent({
  __name: 'DynamicInput',
  props: {
    template: {},
    templates: {},
    title: {},
    preview: {}
  },
  emits: ["update", 'preview'],
  setup(__props: any, { emit: __emit }) {


const route = useRoute()
const editor = route.meta.editor as AEditor;
const props = __props
const emit = __emit
const info = reactive({
  tpl: props.template,
  title: {
    open: false,
    tpl: props.template,
    variableLoading: false,
    variables: [] as string[],
  },
})

watch(() => editor.active.preview.branch_id, () => {
  editor.titlePreview(info.title.tpl).then(t => {
    info.title.open = false
    emit('update', info.title.tpl)
    emit('preview', t)
  })
})

const onTitleEditShow = () => {
  info.title.open = true
  if (info.title.variables.length == 0) {
    info.title.variableLoading = true
    editor.titleVariables().then((value) => {
      info.title.variables = value
    }).finally(() => info.title.variableLoading = false)
  }
}

const onTitleChange = () => {
  editor.titlePreview(info.title.tpl).then(t => {
    info.title.open = false
    emit('update', info.title.tpl)
    emit('preview', t)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_typography_text, null, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.preview) + " ", 1),
        _createVNode(_component_a_button, {
          size: "small",
          type: "link",
          icon: h(_unref(EditOutlined)),
          onClick: onTitleEditShow
        }, null, 8, ["icon"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: __props.title ?? '编辑标题',
      open: info.title.open,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((info.title.open) = $event)),
      onOk: onTitleChange,
      width: "720px",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_flex, {
          vertical: "",
          gap: "middle",
          style: {"padding-top":"12px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_textarea, {
              value: info.title.tpl,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((info.title.tpl) = $event)),
              autofocus: ""
            }, null, 8, ["value"]),
            _createVNode(_component_a_spin, {
              spinning: info.title.variableLoading
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_flex, {
                  gap: "small",
                  wrap: "wrap"
                }, {
                  default: _withCtx(() => [
                    _cache[3] || (_cache[3] = _createTextVNode(" 添加变量： ", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(info.title.variables, (v) => {
                      return (_openBlock(), _createBlock(_component_a_button, {
                        key: v,
                        size: "small",
                        type: info.title.tpl.includes(v) ? 'primary' : 'default',
                        ghost: info.title.tpl.includes(v),
                        onClick: ($event: any) => (info.title.tpl+=`<${v}>`)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(v), 1)
                        ]),
                        _: 2
                      }, 1032, ["type", "ghost", "onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["spinning"]),
            (__props.templates.length>0)
              ? (_openBlock(), _createBlock(_component_a_menu, {
                  key: 0,
                  items: __props.templates.map(t => ({key:t,label:t})),
                  onClick: _cache[1] || (_cache[1] = (evt) => info.title.tpl = evt.key)
                }, null, 8, ["items"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title", "open"])
  ], 64))
}
}

})